'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    dataIterator: {
        rowsPerPageText: 'Elementi per pagina:',
        rowsPerPageAll: 'Tutti',
        pageText: '{0}-{1} di {2}',
        noResultsText: 'Nessun risultato trovato',
        nextPage: 'Pagina seguente',
        prevPage: 'Pagina precedente'
    },
    dataTable: {
        rowsPerPageText: 'Righe per pagina:'
    },
    noDataText: 'Nessun elemento disponibile',
    carousel: {
        prev: 'Precedente visivo',
        next: 'Next visual'
    }
};
//# sourceMappingURL=it.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/vuetify/es5/locale/it.js
// module id = UXUi
// module chunks = 90